import React from 'react'
import CommonPaymentAddEditVerify from './CommonPaymentAddEditVerify';
import { PROD } from '../../common/constants';

function RoyaltyPaymentAddEditVerify() {
  
  return (
    <div>
      {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>PAY04</p>}
      <CommonPaymentAddEditVerify paymentType="Royalty"/>
    </div>
  )
}

export default RoyaltyPaymentAddEditVerify;